export default __webpack_public_path__ + "static/media/char_frame_bg.7a65fc48.png";